import { JsonObject } from '../../helpers';
import { ConnectorFeatureSet, ConnectorUser } from '.';
import { ConnectorModel } from './connector.model';

export type AppConfig = {
  connectorId: string;
  user: ConnectorUser;
  userId: string;
};

export class AppConnectorModel extends ConnectorModel {
  config: AppConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'app';
    this.typeLabel = 'App';
    this.icon = 'sdk';

    this.supportedFeatures = (data.supportedFeatures as ConnectorFeatureSet) || {
      siem: false,
      privateModels: false,
      contextData: false,
      ingress: true,
    };

    this.config = (data.config as AppConfig) || {
      connectorId: '',
      user: undefined,
      userId: '',
    };

    this.demo = true;
  }
}
